import { Component, forwardRef } from '@angular/core';
import CalendarUiComponent from '@iupics-components/standard/fields/calendar-ui/calendar-ui.component';
import GridViewUiComponent from '@iupics-components/standard/grid/grid-view-ui/grid-view-ui.component';
import { DateUtils } from '@iupics-util/tools/date.utils';
import { CellEditorComp, CellEditorParams } from '@iupics/apiz-grid';

@Component({
  selector: 'iu-calendar-editor',
  template: `
    <iu-calendar-ui
      [cssClass]="'defaultDateCalendar p-col-12 calendarEditor'"
      [data]="{ needTime: this.templates.needTime }"
      [fieldValue]="this.fieldValue"
      [isGridEditor]="true"
      [isLabelDisplay]="false"
      [isStandalone]="true"
      (checkGridEditorEmitter)="onCalendar($event)"
      (fieldValueModified)="onFieldModified($event)" />
  `,
  standalone: true,
  imports: [forwardRef(() => CalendarUiComponent)],
})
export default class CalendarEditorComponent implements CellEditorComp {
  params: CellEditorParams;
  label: string;
  templates: any;
  fieldValue = null;
  activeGridView: GridViewUiComponent;

  gridInit(params: CellEditorParams) {
    this.params = params;
    this.label = this.params.label || null;
    this.templates = this.params.templates;
    this.activeGridView = this.params.activeGridView;
    this.#setFieldValue(params);
  }

  refresh(params: CellEditorParams): boolean {
    this.#setFieldValue(params);
    return true;
  }

  #setFieldValue(params: CellEditorParams) {
    if (params.value) {
      this.fieldValue = DateUtils.toDate(params.value);
    }
  }

  getValue() {
    return this.fieldValue;
  }

  onFieldModified($event) {
    const oldValue = this.params.row.getData(this.templates.columnName);
    let newValue: string;
    if ($event) {
      newValue = DateUtils.formatStr($event);
    }
    this.params.row.setData({ [this.templates.columnName]: newValue });

    if (!this.params.row.isSelected()) {
      this.params.row.setSelected(true); // select row
    }

    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.row.getRowData(),
        columnName: this.params.colDef.field,
        oldValue,
        newValue,
        // ...something
      };
      this.params.onClick({ ...this.params, ...params });
    }
  }

  onCalendar(event: any) {
    this.params.onCalendar(event);
  }
}
